/*
 * SPDX-FileCopyrightText: © 2024 Schneider Electric
 *
 * SPDX-License-Identifier: Apache-2.0
 */

@import url('../shared.css');

:host {
  display: inline-block;
  height: 1em;
  width: 1em;
}

.qds-container {
  position: relative;
}

.qds-icon-wrapper {
  display: contents;
}

svg {
  display: block;
  fill: currentcolor;
  height: 100%;
  width: 100%;
}

.qds-click-target {
  height: var(--qds-experimental-icon-click-target-size);
  left: calc(-1 * (var(--qds-experimental-icon-click-target-size) - 100%) / 2);
  position: absolute;
  top: calc(-1 * (var(--qds-experimental-icon-click-target-size) - 100%) / 2);
  width: var(--qds-experimental-icon-click-target-size);
}
